/* global firebase */
import { SET_ERRORS, CLEAR_ERRORS, LOADING_UI, LOGOUT_USER, SET_NO_AUTH_REDIRECT_FROM_URL, OPEN_SNACKBAR } from "../types";
import { auth } from "../../firebase/firebase";
import * as ROUTES from "../../utils/routes";
import logAnalyticsEvent from "../../utils/logAnalyticsEvent";
import { restApiNoAuth, unixTimestamp } from "./utils";
import store from "../store";

export const loginUser = (email, pass) => dispatch => login(email, pass, dispatch);

export const login = (email, pass, dispatch) => {
  dispatch({ type: LOADING_UI, payload: true });
  auth
    .signInWithEmailAndPassword(email, pass)
    .then(() => {
      dispatch({ type: LOADING_UI, payload: false });
      dispatch({ type: CLEAR_ERRORS });
      logAnalyticsEvent("log_in", true);
    })
    .catch(error => {
      dispatch({ type: LOADING_UI, payload: false });
      dispatch({ type: SET_ERRORS, payload: error.message });
    });
};

export const logout = history => dispatch => {
  auth.signOut().then(() => {
    history.push(ROUTES.LOGIN);
    dispatch({ type: SET_NO_AUTH_REDIRECT_FROM_URL, payload: "" });
    dispatch({ type: LOGOUT_USER });
    logAnalyticsEvent("log_out");
  });
};

export const onUserLogin = history => dispatch => {
  const state = store.getState();
  if (state.ui.noAuthRedirectFromUrl != "") {
    history.push(state.ui.noAuthRedirectFromUrl);
  } else {
    history.push(ROUTES.DASHBOARD);
  }
};

export const addNewUser = ({
  name,
  email,
  role,
  password,
  organizationKey
}) => dispatch => {
  dispatch({ type: LOADING_UI, payload: true });

  const createUser = firebase.functions().httpsCallable('createUser');
  createUser({
    name,
    email,
    password,
    role,
    organizationKey
  })
    .catch(error => {
      dispatch({ type: SET_ERRORS, payload: error.message });
    });
};

export const editUser = ({
  selectedUserKey,
  name,
  email,
  role,
  password
}) => dispatch => {
  dispatch({ type: LOADING_UI, payload: true });

  const updateUser = firebase.functions().httpsCallable('updateUser');
  updateUser({
    userId: selectedUserKey,
    name,
    email,
    password,
    role
  })
    .catch(error => {
      dispatch({ type: SET_ERRORS, payload: error.message });
    });
};

export const deleteUser = ({ userKey }) => dispatch => {
  dispatch({ type: LOADING_UI, payload: true });

  const deleteUser = firebase.functions().httpsCallable('deleteUser');
  deleteUser({
    userId: userKey
  })
    .catch(error => {
      dispatch({ type: SET_ERRORS, payload: error.message });
    });
};

export const signUpNewUser = ({ email, pass, orgName, betaKey, history }) => dispatch => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: LOADING_UI, payload: true });
  restApiNoAuth("signUpNewUser", { email, pass, orgName, betaKey })
    .then(res => res.json())
    .then(data => {
      if (data.error) {
        dispatch({
          type: SET_ERRORS,
          payload: data.error.message
        });
        logAnalyticsEvent("sign_up", { email, orgName, betaKey }, true);
      } else {
        history.push(ROUTES.LOGIN);
        dispatch({ type: LOADING_UI, payload: false });
        dispatch({
          type: OPEN_SNACKBAR,
          payload: {
            message: "Account creation successful! Please sign in with your new account.",
            timestamp: unixTimestamp()
          }
        })
      }
    })
    .catch(console.log);
};